<template>
  <div class="ldar-detail">
    <div class="container">
      <h1>{{ serviceDetail.title }}</h1>
      <div class="service-meta">
        <span class="service-category">{{ serviceDetail.category }}</span>
      </div>
      <div class="service-content">
        <div class="service-hero-image" v-if="serviceDetail.heroImage">
          <img :src="serviceDetail.heroImage" :alt="serviceDetail.title" />
        </div>
        <div class="service-description" v-if="serviceDetail.description || serviceDetail.description1 || serviceDetail.descriptionImage || serviceDetail.descriptionText || serviceDetail.descriptionImage2 || serviceDetail.description2 || $route.params.id === 'solution-2' || $route.params.id === 'solution-3'">
          <h2>{{ $route.params.id === 'solution-2' || $route.params.id === 'solution-3' ? '介绍' : '产品介绍' }}</h2>
          <template v-if="$route.params.id === 'solution-3'">
            <p>{{ serviceDetail.description1 }}</p>
            <div class="service-image" v-if="serviceDetail.descriptionImage">
              <img :src="serviceDetail.descriptionImage" :alt="serviceDetail.title" class="service-main-image" />
            </div>
            <p>{{ serviceDetail.description2 }}</p>
            <div class="service-image" v-if="serviceDetail.descriptionImage2">
              <img :src="serviceDetail.descriptionImage2" :alt="serviceDetail.title" class="service-main-image" />
            </div>
          </template>
          <template v-else>
            <p v-for="(paragraph, index) in serviceDetail.description.split('\n\n')" :key="index">{{ paragraph }}</p>
            <div class="service-image" v-if="serviceDetail.descriptionImage">
              <img :src="serviceDetail.descriptionImage" :alt="serviceDetail.title" class="service-main-image" />
            </div>
            <p v-if="serviceDetail.descriptionText" class="description-text">{{ serviceDetail.descriptionText }}</p>
            <div class="service-image" v-if="serviceDetail.descriptionImage2">
              <img :src="serviceDetail.descriptionImage2" :alt="serviceDetail.title" class="service-main-image" />
            </div>
          </template>
          <div class="service-image" v-if="$route.params.id === 'solution-2'">
            <img :src="require('../assets/21.png')" alt="红外气体成像检测服务（OGI）" class="service-main-image" />
          </div>
          <div class="service-advantages" v-if="$route.params.id === 'solution-3' && serviceDetail.advantages && serviceDetail.advantages.length > 0">
            <h2>突出优势</h2>
            <ul>
              <li v-for="(advantage, index) in serviceDetail.advantages" :key="index">{{ advantage }}</li>
            </ul>
          </div>
          <div class="service-application-areas" v-if="$route.params.id === 'solution-3' && serviceDetail.applicationAreas && serviceDetail.applicationAreas.length > 0">
            <h2>应用领域</h2>
            <ul>
              <li v-for="(area, index) in serviceDetail.applicationAreas" :key="index">{{ area }}</li>
            </ul>
          </div>
          <div class="service-application-scenarios" v-if="$route.params.id === 'solution-3'">
            <h2>应用场景</h2>
            <div class="service-images">
              <img :src="require('../assets/22.png')" alt="应用场景1" class="service-main-image" />
              <img :src="require('../assets/23.png')" alt="应用场景2" class="service-main-image" />
              <img :src="require('../assets/24.png')" alt="应用场景3" class="service-main-image" />
              <img :src="require('../assets/25.png')" alt="应用场景4" class="service-main-image" />
            </div>
          </div>
        </div>
        <div class="service-features" v-if="$route.params.id !== 'device-3' && $route.params.id !== 'device-5' && $route.params.id !== 'solution-2' && $route.params.id !== 'solution-3' && serviceDetail.features && serviceDetail.features.length > 0">
          <h2>{{ serviceDetail.featuresTitle || '产品特性' }}</h2>
          <ul>
            <li v-for="(feature, index) in serviceDetail.features" :key="index">{{ feature }}</li>
          </ul>
        </div>

        <div class="service-benefits" v-if="$route.params.id !== 'solution-2' && $route.params.id !== 'solution-3' && serviceDetail.benefits && serviceDetail.benefits.length > 0 && serviceDetail.benefits[0] !== ''">
          <h2>产品优势</h2>
          <div class="benefits-grid">
            <div class="benefit-item" v-for="(benefit, index) in serviceDetail.benefits" :key="index">
              <div class="benefit-icon">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M9 16.17L4.83 12L3.41 13.41L9 19L21 7L19.59 5.59L9 16.17Z" fill="#42b983"/>
                </svg>
              </div>
              <p>{{ benefit }}</p>
            </div>
          </div>
        </div>

        <div class="service-core-features" v-if="$route.params.id !== 'solution-2' && $route.params.id !== 'solution-3' && serviceDetail.coreFeaturesList && serviceDetail.coreFeaturesList.length > 0">
          <h2>核心功能</h2>
          <div class="core-features-list">
            <ul>
              <li v-for="(feature, index) in serviceDetail.coreFeaturesList" :key="index">{{ feature }}</li>
            </ul>
          </div>
          <div class="service-image" v-if="serviceDetail.coreFeaturesImage">
            <img :src="serviceDetail.coreFeaturesImage" :alt="serviceDetail.title" class="service-main-image" />
          </div>
        </div>

        <div class="service-sections" v-if="serviceDetail.sections && serviceDetail.sections.length > 0">
          <div class="section-item" v-for="(section, index) in serviceDetail.sections" :key="index">
            <h2>{{ section.title }}</h2>
            <p v-if="section.content">{{ section.content }}</p>
            <div class="service-image" v-if="section.image">
              <img :src="section.image" :alt="section.title" class="service-main-image" />
            </div>
            <div class="service-image" v-if="section.image2">
              <img :src="section.image2" :alt="section.title" class="service-main-image" />
            </div>
            <p v-if="section.contentAfterImage">{{ section.contentAfterImage }}</p>
            <div class="service-image" v-if="section.imageAfterContent">
              <img :src="section.imageAfterContent" :alt="section.title" class="service-main-image" />
            </div>
            <div class="service-image" v-if="section.imageAfterContent2">
              <img :src="section.imageAfterContent2" :alt="section.title" class="service-main-image" />
            </div>
            <p v-if="section.contentAfterImage2">{{ section.contentAfterImage2 }}</p>
          </div>
        </div>

      </div>
      <div class="back-link">
        <router-link to="/ldar">← 返回LDAR检测</router-link>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AppLdarDetail',
  data() {
    return {
      serviceDetail: {
        title: '',
        category: '',
        description: '',
        heroImage: '',
        features: [],
        benefits: [],
        gallery: []
      }
    }
  },
  mounted() {
    this.loadServiceDetail(this.$route.params.id);
  },
  methods: {
    loadServiceDetail(id) {
      const serviceData = {
        'device-1': {
          title: '讯飞声学成像仪',
          category: '我们的设备',
          description: '声学成像是基于传声器阵列测量技术，通过测量一定空间内的声波到达各传声器的信号相位差异，依据相控阵原理确定声源的位置，测量声源的幅值，并以图像的方式显示声源在空间的分布，取得空间声场分布云图－声像图。讯飞声学成像仪利用高灵敏度数字麦克风，并将声像图与可见光图像叠加，将采集的声音以彩色等高线图谱的方式可视化呈现在屏幕上。具备识别定位和测试分析系统，支持多点声源识别，可以为用户提供快速、准确的泄漏源分布图，提升检测速度和效率。',
          descriptionText: '讯飞声学成像仪是非接触式检测，不受电磁和设备振动干扰。通过对空间的扫描式巡检，快速排查泄漏点，清晰反映出管道泄漏位置，又可以有效屏蔽现场噪声干扰，同时看到多个泄漏点。相较于传统单点检测手段，如人力检测、超声波探测等，它可以同时进行超过400个点位的检测，因而方便进行大面积排查。',
          heroImage: require('../assets/11.jpg'),
          descriptionImage: require('../assets/12.jpg'),
          descriptionImage2: require('../assets/13.jpg'),
          featuresTitle: '产品特性',
          features: [
            '设备操作简单便捷，3分钟快速上手作业；',
            '支持泄漏量评估功能，评估泄漏等级及泄漏量；',
            '支持拍照模式、视频模式，作业现场数据灵活记录；',
            '配套PC端工具软件，一键导出测试报告；',
            '效率高，即时成像，迅速定位画面中的泄漏点。'
          ],
          benefits: [
            ''
          ],
          benefitsImage: require('../assets/14.jpg'),
          coreFeaturesImage: require('../assets/15.jpg'),
          coreFeaturesList: [
            '● 频率调整：可定位不同频率声源，通过调整频段过滤出特定频段的声音，有效排除环境干扰快速定位',
            '● 定向拾音/定向抑制：在定位到声音异常的位置之后，增强该特定位置的声音，方便根据该声音的频率音调等特点推测异常的类型。同时可抑制其他方向的噪声干扰',
            '● 拍照&录像：通过照片或视频的方式记录设备异常数据，存档记录，可随时回看照片/视频，方便问题数据保存及问题跟踪',
            '● 分贝测量：可测量指定位置的分贝和距离，辅助判断声源情况',
            '● 瞬态模式：用于延长展示人眼难以捕捉的瞬态声源在画面中的停留时间，便于声源定位',
            '● 色带调节：调节热力图成像的分贝范围，可删减或扩大展示范围',
            '● 时频图：直观展示声源频率成分，辅助用户分析判断异响类型'
          ],
          gallery: [
            require('../assets/11.jpg'),
            require('../assets/11.jpg'),
            require('../assets/11.jpg')
          ]
        },
        'device-2': {
          title: 'Model 115 FID 便携式VOCs分析仪',
          category: '我们的设备',
          description: 'Model115便携式VOCs分析仪采用FID检测器，检测器使用氢气和助燃气产生氢火焰，当有机化合物进入到燃烧火焰时会被离子化。离子化产生的自由电子束通过探测器中的极化电极被直接送到检测电路中。检测电路将此电子束作为电流来处理，电流大小取决与探测器中有机挥发物的含量，通过测量电流，可计算出VOCs的浓度。美国PID分析仪器公司是全球套PID检测仪器制造商，公司创始于1974年，至今已销售了超过10万套的便携式分析仪器，其中90%以上的仪器仍在正常运行。',
          heroImage: require('../assets/15.png'),
          features: [
            '坚固耐用；',
            '测量速度快，T90响应时间＜3S；',
            '模块化设计，测量探头和主机可分离，随时随地方便更换探头，实现多种测量功能；',
            '测量准确可靠，超稳定FID检测器和零点自动校正技术；',
            '维护量小，无需频繁清洁测量室；',
            '对所有VOCs气体均有响应，可测量各种碳氢化合物；',
            '测量范围宽，从0.1ppm~30000ppm或更高；',
            '易充式迷你氢气瓶，安全低压，非专业人士也可使用；',
            '内置高性能气泵；',
            '可充电锂电池；',
            '测量数据可存储和导出至PC；'
          ],
          benefits: [
            ''
          ],
          gallery: [
            require('../assets/15.png'),
            require('../assets/15.png')
          ]
        },
        'device-3': {
          title: 'TVA2020C（FID+PID)双模有毒气体分析仪',
          category: '我们的设备',
          description: 'TVA2020C 有毒挥发气体分析仪具备同时检测有机和无机化合物的能力。 \n TVA2020C分析仪广泛应用于包括遵循美国EPA方法21监测的现场、现场修复检测、垃圾填埋环境监测、以及常规的区域环境调查。 \n \n FID/PID双检测器分析仪具有更强的分析能力,能同时对所有有机化合物和部分无机化合物快速响应；而和同体积的其他仪器比较，能提供更全面的气体覆盖。 \n \n TVA2020C在校正后，就可以进行自定义设置，比如设置内部数据记录参数、上传监测路径、建立蓝牙连接、设定报警级别、选择响应因子。 \n \n 蓝牙通讯功能，可以将大量的测量数据直接发送到内置LDAR软件的手持设备上，能更好地根据路径信息进行监测。',
          heroImage: require('../assets/16.jpg'),
          features: [
            'FID+PID双检测器，同时检测有机和无机化合物',
            '高精度检测，响应速度快',
            '广泛应用于多种环境监测场景',
            '符合美国EPA方法21监测标准',
            '便携式设计，便于现场操作',
            '数据存储和导出功能'
          ],
          benefits: [
            ''
          ],
          gallery: [
            require('../assets/16.jpg'),
            require('../assets/16.jpg')
          ]
        },
        'device-4': {
          title: 'LDAR系列手操器',
          category: '我们的设备',
          description: '手持式移动数据采集器（手操器） 是一台基于Andriod研发的具备在高危作业环境下的高性能设备。其内置有先进的LDAR图像及数据采集处理软件，具备拍照、图片点位标注、及相关数据信息录采集录入等功能。',
          heroImage: require('../assets/17.jpg'),
          featuresTitle: '产品优势',
          features: [
            '高危作业环境下的专用电子设备',
            '该手抄器还可分别通过蓝牙模块建立与数据检测设备，移动通信模块与我们的互联网数据库的连接，轻松实现将检测设备的检测数据智能同步到手抄器系统及上传至LDAR数据库，这样既大大提高了数据录入效率，又保证了点位与数据信息的匹配准确度。',
            '精准的数据信息采集录入为我们高标高效的LDAR服务提供了有力的保障。'
          ],
          benefits: [
            ''
          ],
          gallery: [
            require('../assets/17.jpg'),
            require('../assets/17.jpg')
          ]
        },
        'device-5': {
          title: '长波型红外气体检漏成像仪',
          category: '我们的设备',
          description: '便携式红外气体检漏成像仪是利用热成像原理，截取正在发生泄漏且无形的挥发性有机物排放的影像资料。该仪器广泛用于石油化工行业的挥发性有机物气体泄漏和 无组织排放检测，可用以评估工厂设备的产品损失、识别泄漏排放源，并结合其他修复措施，达到VOCs减排的目的。\n\n此设备属长波型红外气体检漏成像仪，大大增加了可探波长范围和可探气体种类。',
          heroImage: require('../assets/18.jpg'),
          features: [
            '长波型红外成像技术，增加可探波长范围',
            '可探测多种气体种类',
            '高分辨率成像，清晰显示泄漏位置',
            '实时成像，动态监测泄漏情况',
            '便携式设计，方便现场操作',
            '数据存储功能，支持历史查询'
          ],
          benefits: [
            ''
          ],
          gallery: [
            require('../assets/18.jpg'),
            require('../assets/18.jpg')
          ]
        },
        'device-6': {
          title: 'EyeCGas红外气体检漏成像仪',
          category: '我们的设备',
          description: '',
          heroImage: require('../assets/19.jpg'),
          features: [
            '1、专为工业领域设计——适用于工业废气、有机化合物、有毒气体排放的工况，该红外气体成像仪坚固耐用，密封性良好，适合在户外工况下使用。',
            '2、EyeCGas严格符合国际电工委员会（IEC）的环境适应要求，具备温度、湿度、防振、防尘和防水认证。',
            '3、安全——EyeCGas是世界同行中唯一取得CSA本质安全认证的红外气体成像仪，本质安全等级如下：Class 1 Div 2，可工作于存在爆炸性气体的区域。',
            '4、增强的图像——我们的技术专家在红外热成像技术方面拥有超过60年的经验，EyeCGas使用合适的增强型热成像技术来确保能够对微小气体泄漏进行检测和定位。',
            '5、上游、中游及下游行业的整合能力',
            '6、声频、视频记录——EyeCGas提供实时的声频视频录像，改进报告和离线分析。',
            '7、50m之外可能轻松定位泄漏点。可快速探测到接触式检测工具难以触及的区域。',
            '8、具快速大片区扫检功能。如果泄露，立即发现。',
            '9、同时检测多个组件。',
            '10、16G内存卡，超过8小时超长视频保存。',
            '11、无线蓝牙连接。',
            '12、通过USB连接对系统软件升级更新。',
            '13、防水防尘防爆。',
            '14、Rugged 坚固耐用',
            '15、便携方便，操作简单。'
          ],
          benefits: [
            ''
          ],
          gallery: [
            require('../assets/19.jpg'),
            require('../assets/19.jpg')
          ]
        },
        'solution-1': {
          title: 'LDAR检测服务实施流程',
          category: '解决方案',
          description: '',
          heroImage: require('../assets/19.png'),
          sections: [
            {
              title: '项目准备',
              content: '用户需求分析，建立实施方案，与客户进行沟通，对客户需求进行分析，建立详细的实施方案。入厂安全培训、协调及资料收集，确定项目的范围、进度安排、最终交付成果。\n\n主要工作安排如下：\n\n· 与客户进行沟通，对客户需求进行分析，建立详细的实施方案；\n\n· 项目开工会，制定执行计划、指明项目团队、设备调度及大致时间进度表；\n\n· 内勤安排，指定临时办公地点、准备办公用品、现场联系人，明确需提前采购的设备、耗材等；\n\n· 入厂安全培训，收集相关资料，如物料平衡表、PFD、P&ID图纸等。'
            },
            {
              title: '项目建立',
              content: '审核图纸，确定管线组件\n\n根据客户提供的工艺原则流程图（PFD）、管道及仪表流程图（P&ID），分析VOCs所在的具体组件位置，从而对排放源管线和组件进行定位。\n\n设备组件现场定位、描述',
              image: require('../assets/16.png'),
              contentAfterImage: '现场设备及组件定位、挂牌、拍照、照片预编辑、基础信息描述收集',
              imageAfterContent: require('../assets/17.png'),
              imageAfterContent2: require('../assets/18.png'),
              contentAfterImage2: '信息编辑、录入，建立数据库'
            },
            {
              title: '现场检测',
              content: '现场LDAR项目建立完成之后，需要对纳入LDAR检测范围之内的组件进行检测。检测分为两个方面：（1）常规组件的检测；（2）难于检测（DTM）、险于检测（UTM）组件的检测。',
              image: require('../assets/19.png'),
              image2: require('../assets/20.png')
            },
            {
              title: '数据管理',
              content: '数据库管理平台可追踪VOCs排放源和检测数据、管理检测和修复信息、计算各种不同类型的VOCs排放源的排放量。\n\n1. 现场管理\n\n在检测和维修管理模块，可以从数据库中将检测/维修数据下载到LDAR数据管理平台移动设备中。\n\n2. 查看管理\n\n在查看管理模块中，可以使用装置、区域、标签和扩展号来快速搜索组件。\n\n3. 报告管理\n\n报告管理模块中，可以生成、归档报告，可生成VOCs排放量计算报告，可查看和编辑VOCs排放公式。\n\n4. 工具管理\n\n在工具栏管理模块中，可以修改系统选项。\n\n5. 安全管理\n\n在安全管理模块中，管理员可以添加、修改和删除用户系统。\n\n6. 参数设置\n\n参数设置主要对后台参数进行设置'
            }
          ],
          gallery: [
            'https://picsum.photos/600/400?random=151',
            'https://picsum.photos/600/400?random=152',
            'https://picsum.photos/600/400?random=153'
          ]
        },
        'solution-2': {
          title: '红外气体成像检测服务（OGI）',
          category: '解决方案',
          description: '气体泄漏检测设备是保证您的员工健康，环境保护以及工艺安全的有效工具，它能帮助寻找挥发性有机化合物（VOCs）的泄漏点，减少寻找无组织泄漏的时间，让您对工厂中无组织排放的气体泄漏不再束手无策。我公司主要针对石油石化及天然气行业可以提供红外检测服务。隆智环保可以定期对全厂进行红外摄像仪扫描检测排查，或者在企业存在安全隐患的时期（例如开试车、停车和维修等阶段）进行检测，还可以用于对新建装置的检测等，也可配合TVA2020等设备进行更为详细的LDAR检测及LDAR平台服务，从而更好的达到降低物料损失，减少安全隐患的最终目标。\n\n防爆型红外气体成像检漏仪专为天然气、石油化工行业市场应用而设计，充分考虑到专家级用户高敏感度的需求。与现在市场上的便携式光学成像仪相比，能探测到更小的泄漏。对不可见光谱的高灵敏度，让用户通过肉眼可以检测到无组织排放气体的泄漏，即使远距离，用户也可以很容易发现泄漏发生的精确位置。\n\n我公司设备先进，齐全：拥有国际安全防爆认证的进口EyeCGas红外气体检漏成像仪（可探波长范围：3-5μm），以及由中国安全生产科学研究院科技成果转化而来的新型长波红外气体成像仪（波长范围7-11μm）两种不同波段的检测设备。 两种波段的探测设备的配合使用，使我公司可基本实现对炼油，化工，医药等行业中大多数有机挥发性气体（VOCs）种类的全覆盖。',
          features: [
            '专业检测团队，经验丰富',
            '先进检测设备，精度高',
            '系统化检测流程，确保全面覆盖',
            '快速响应，及时完成检测任务',
            '详细检测报告，提供数据支持',
            '修复建议，指导企业整改'
          ],
          benefits: [
            '省心省力，无需企业自行组织',
            '专业可靠，检测结果准确',
            '高效快捷，缩短检测周期',
            '合规保障，符合环保标准',
            '成本合理，性价比高',
            '持续支持，提供后续服务'
          ],
          gallery: [
            'https://picsum.photos/600/400?random=154',
            'https://picsum.photos/600/400?random=155'
          ]
        },
        'solution-3': {
          title: '声学成像检测解决方案 ——轻松"看见"泄漏点',
          category: '解决方案',
          description1: '声学成像检测通过声成像技术，将声像图与可见光图像叠加，实现声音实时可视化，让工业故障设备的声音、工业气体泄漏的声音统统"看得见"。',
          descriptionImage: require('../assets/21.jpg'),
          description2: '讯飞声学成像仪利用高精度麦克风阵列及超声波声源定位技术获取声源分布数据，结合高清光学摄像头，实时采集视频画面，通过声像图与可见光图像叠加的成像方式进行声像融合，在显示屏上实时展示声源动态及其在空间的分布状态，快速确定气体泄漏点、设备异响位点，提升巡检效率和检修速度。',
          descriptionImage2: require('../assets/11.jpg'),
          advantages: [
            '让泄漏"看得见"：即时成像，迅速定位画面中的泄漏点，实时显示泄漏气体声波分布热力图，支持同时检测多个点位。',
            '高效定位泄漏源：通过空间区域扫描，快速排查泄漏点，可同时进行超过400个点位的检测，大大缩减巡检时间。',
            '有效过滤环境噪音：1-65kHz可调频率，搭配聚焦功能屏蔽干扰声源，支持在嘈杂的工业环境中快速判定泄漏源。',
            '判定泄漏强度：实时显示泄漏点声压等级，后台支持泄漏量评估功能，可根据设备分析出的湍流声压，判定泄漏等级及泄漏量。',
            '检测现场可追溯：具备拍照和录像功能，1300万像素高清自动捕捉泄漏点，作业现场数据灵活记录，方便后续排查和分析工作。',
            '辅助生成检测报告：配套PC端工具软件，提供局放检测报告模板，可基于检测数据，一键导出检测报告。'
          ],
          applicationAreas: [
            '广泛应用于带压或真空条件下的气体泄漏检测、气密性检测、设备异响定位等多种场景。适用于石油和天然气企业、天然气运输管道、工厂罐区、天然气发电厂、炼油厂、制造工厂等众多场所，早检测早发现，防患于未然。'
          ],
          applicationScenarios: [
            '工厂巡检：定期对工厂设备进行全面检测，及时发现潜在泄漏问题',
            '设备维护：在设备维护过程中，使用声学成像仪快速定位故障点',
            '泄漏排查：针对特定区域的泄漏问题进行专项排查',
            '安全检测：在高危作业环境中，非接触式检测减少人员风险',
            '应急响应：在发生泄漏事故时，快速定位泄漏源，指导应急处理',
            '合规检查：为企业提供符合环保标准的检测报告，满足监管要求'
          ],
          features: [
            '理论培训，讲解LDAR基础知识',
            '实操培训，指导设备操作',
            '数据管理培训，教授系统使用',
            '修复技术培训，讲解修复方法',
            '案例分析，分享实际经验',
            '考核认证，确保培训效果'
          ],
          benefits: [
            '提升能力，建立自主检测能力',
            '降低成本，减少外包服务',
            '规范操作，统一检测标准',
            '持续改进，优化检测流程',
            '团队建设，培养专业人才',
            '合规经营，满足监管要求'
          ],
          gallery: [
            'https://picsum.photos/600/400?random=156',
            'https://picsum.photos/600/400?random=157'
          ]
        }
      };
      
      this.serviceDetail = serviceData[id] || {
        title: '服务不存在',
        category: '',
        description: '抱歉，您访问的服务不存在或已被删除。',
        heroImage: '',
        features: [],
        benefits: [],
        gallery: []
      };
    }
  }
}
</script>

<style scoped>
.ldar-detail {
  padding: 80px 0;
  background: linear-gradient(135deg, #f9f9f9 0%, #e6f3ee 100%);
}

.container {
  max-width: 1000px;
  margin: 0 auto;
  padding: 0 20px;
}

h1 {
  font-size: 36px;
  margin-bottom: 20px;
  color: #333;
  text-align: center;
}

.service-meta {
  text-align: center;
  margin-bottom: 40px;
}

.service-category {
  display: inline-block;
  background-color: #42b983;
  color: white;
  padding: 8px 20px;
  border-radius: 4px;
  font-size: 16px;
}

.service-content {
  background-color: #fff;
  padding: 40px;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  margin-bottom: 40px;
}

.service-hero-image {
  width: 100%;
  height: 400px;
  overflow: hidden;
  border-radius: 8px;
  margin-bottom: 40px;
}

.service-hero-image img {
  width: 100%;
  height: 100%;
  object-fit: contain;
  background-color: #f9f9f9;
}

.service-main-image {
  width: 100%;
  max-width: 100%;
  height: auto;
  border-radius: 8px;
  margin-top: 20px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  object-fit: contain;
  background-color: #f9f9f9;
}

.service-description h2,
.service-features h2,
.service-benefits h2,
.service-core-features h2,
.service-advantages h2,
.service-sections h2,
.service-gallery h2 {
  font-size: 28px;
  color: #333;
  margin-bottom: 20px;
  padding-bottom: 10px;
  border-bottom: 2px solid #42b983;
}

.service-advantages {
  margin: 40px 0;
}

.service-advantages ul {
  list-style: none;
  padding: 0;
  margin-bottom: 30px;
}

.service-advantages li {
  font-size: 16px;
  color: #333;
  line-height: 1.8;
  margin-bottom: 15px;
  padding-left: 30px;
  position: relative;
}

.service-advantages li::before {
  content: '✓';
  position: absolute;
  left: 0;
  color: #42b983;
  font-weight: bold;
  font-size: 18px;
}

.service-application-areas {
  margin: 40px 0;
}

.service-application-areas ul {
  list-style: none;
  padding: 0;
  margin-bottom: 30px;
}

.service-application-areas li {
  font-size: 16px;
  color: #333;
  line-height: 1.8;
  margin-bottom: 15px;
  padding-left: 30px;
  position: relative;
}

.service-application-areas li::before {
  content: '▸';
  position: absolute;
  left: 0;
  color: #42b983;
  font-weight: bold;
  font-size: 18px;
}

.service-application-scenarios {
  margin: 40px 0;
}

.service-application-scenarios ul {
  list-style: none;
  padding: 0;
  margin-bottom: 30px;
}

.service-application-scenarios li {
  font-size: 16px;
  color: #333;
  line-height: 1.8;
  margin-bottom: 15px;
  padding-left: 30px;
  position: relative;
}

.service-application-scenarios li::before {
  content: '▶';
  position: absolute;
  left: 0;
  color: #42b983;
  font-weight: bold;
  font-size: 18px;
}

.service-images {
  display: grid;
  grid-template-columns: 1fr;
  gap: 20px;
  margin-top: 30px;
}

.service-images img {
  width: 100%;
  height: auto;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  object-fit: contain;
  background-color: #f9f9f9;
}

.service-sections {
  margin: 40px 0;
}

.section-item {
  margin-bottom: 40px;
}

.section-item p {
  font-size: 16px;
  color: #333;
  line-height: 1.8;
  margin-bottom: 20px;
}

.service-description p {
  font-size: 16px;
  color: #333;
  line-height: 1.8;
  margin-bottom: 30px;
}

.description-text {
  font-size: 16px;
  color: #333;
  line-height: 1.8;
  margin: 20px 0;
}

.core-features-list {
  margin-top: 20px;
}

.core-features-list ul {
  list-style: none;
  padding: 0;
}

.core-features-list li {
  font-size: 16px;
  color: #333;
  line-height: 1.8;
  margin-bottom: 15px;
  padding-left: 20px;
  position: relative;
}

.core-features-list li::before {
  content: '';
  position: absolute;
  left: 0;
  top: 10px;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background-color: #42b983;
}

.service-features ul {
  list-style: none;
  padding: 0;
  margin-bottom: 30px;
}

.service-features li {
  font-size: 16px;
  color: #333;
  line-height: 1.8;
  margin-bottom: 15px;
  padding-left: 30px;
  position: relative;
}

.service-features li::before {
  content: '✓';
  position: absolute;
  left: 0;
  color: #42b983;
  font-weight: bold;
  font-size: 18px;
}

.benefits-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 20px;
  margin-bottom: 30px;
}

.benefit-item {
  display: flex;
  align-items: flex-start;
  padding: 20px;
  background-color: #f9f9f9;
  border-radius: 8px;
  transition: transform 0.3s ease;
}

.benefit-item:hover {
  transform: translateY(-5px);
}

.benefit-icon {
  flex-shrink: 0;
  margin-right: 15px;
}

.benefit-item p {
  font-size: 15px;
  color: #333;
  line-height: 1.6;
  margin: 0;
}

.gallery-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 20px;
}

.gallery-item {
  overflow: hidden;
  border-radius: 8px;
  cursor: pointer;
}

.gallery-item img {
  width: 100%;
  height: 200px;
  object-fit: cover;
  transition: transform 0.3s ease;
}

.gallery-item:hover img {
  transform: scale(1.1);
}

.back-link {
  text-align: center;
}

.back-link a {
  color: #42b983;
  text-decoration: none;
  font-size: 16px;
  font-weight: bold;
  transition: color 0.3s ease;
}

.back-link a:hover {
  color: #3aa876;
  text-decoration: underline;
}

@media screen and (max-width: 768px) {
  .ldar-detail {
    padding: 60px 0;
  }

  h1 {
    font-size: 28px;
  }

  .service-content {
    padding: 30px;
  }

  .service-hero-image {
    height: 300px;
  }

  .service-description h2,
  .service-features h2,
  .service-benefits h2,
  .service-gallery h2 {
    font-size: 24px;
  }

  .benefits-grid {
    grid-template-columns: 1fr;
  }

  .gallery-grid {
    grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  }
}

@media screen and (max-width: 480px) {
  .ldar-detail {
    padding: 40px 0;
  }

  h1 {
    font-size: 24px;
  }

  .service-content {
    padding: 20px;
  }

  .service-hero-image {
    height: 200px;
  }

  .service-description h2,
  .service-features h2,
  .service-benefits h2,
  .service-gallery h2 {
    font-size: 20px;
  }

  .service-description p,
  .service-features li {
    font-size: 14px;
  }

  .benefit-item {
    padding: 15px;
  }

  .benefit-item p {
    font-size: 13px;
  }

  .gallery-grid {
    grid-template-columns: 1fr;
  }

  .gallery-item img {
    height: 180px;
  }
}
</style>